module.exports = __webpack_public_path__ + "sansg/img/jg.fad3e430.png";